import {AxiosResponse} from 'axios';
import type {Request, Response} from 'express';
import {axiosFetch} from '../../axios/axiosInstance';
import {MenuGroupVo} from '../../common/shared/api/karina/vo/menu/MenuGroupVo.interface';
import {SubtabMenuVo} from '../../common/shared/api/karina/vo/menu/SubtabMenuVo.interface';
import {ApiResultV2Vo} from '../../common/shared/api/nicolas/vo/ApiResultV2Vo.interface';
import {ApiStatusCodeVo} from '../../common/shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {PagewebError} from '../../errors/PagewebError.class';
import {PagewebErrorType} from '../../errors/PagewebErrorType.enum';

export async function getViewSubtabList({
  req,
  res,
}: {
  req: Request;
  res: Response;
}) {
  const url = '/view/v2/subtab/list';

  const result: AxiosResponse<ApiResultV2Vo<MenuGroupVo<SubtabMenuVo>>> =
    await axiosFetch({
      req,
      res,
      url,
    });

  if (result.data.result_code === ApiStatusCodeVo.ServerMaintenance) {
    throw new PagewebError({
      isSerializedPagewebError: true,
      type: PagewebErrorType.NicolasApiStatusError,
      message: result.data.message,
      resultCode: result.data.result_code,
    });
  }
  return result.data?.result;
}
